import { getColors, UI_PRIMITIVES } from '@/core/constants/uiColors';
import { Image } from 'expo-image';
import React from 'react';
import { ActivityIndicator, Modal, Platform, StyleSheet, View } from 'react-native';

export interface FullScreenLoaderProps {
    visible: boolean;
}

/**
 * Full-screen blocking loader component
 * Displays a centered loader GIF with a semi-transparent backdrop
 * Blocks all user interaction while visible
 */
export const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ visible }) => {
    if (!visible) {
        return null;
    }

    // Android Expo/release often fails to paint Modal + GIF (blank header).
    // iOS and web keep the existing Modal + GIF.
    if (Platform.OS === 'android') {
        return (
            <View style={styles.androidOverlay} pointerEvents="auto">
                <View style={styles.overlay}>
                    <View style={styles.loaderContainer}>
                        <ActivityIndicator size="large" color={getColors('light').bloomRed} />
                    </View>
                </View>
            </View>
        );
    }

    return (
        <Modal
            visible={visible}
            transparent
            animationType="fade"
            statusBarTranslucent
            hardwareAccelerated
        >
            <View style={styles.overlay}>
                <View style={styles.loaderContainer}>
                    <Image
                        source={require('@assets/images/gif/loader.gif')}
                        style={styles.loaderImage}
                        contentFit="contain"
                    />
                </View>
            </View>
        </Modal>
    );
};

const styles = StyleSheet.create({
    androidOverlay: {
        ...StyleSheet.absoluteFillObject,
        zIndex: 1000,
        elevation: 1000,
    },
    overlay: {
        flex: 1,
        backgroundColor: UI_PRIMITIVES.overlayBackdrop,
        justifyContent: 'center',
        alignItems: 'center',
    },
    loaderContainer: {
        width: 120,
        height: 120,
        justifyContent: 'center',
        alignItems: 'center',
    },
    loaderImage: {
        width: '100%',
        height: '100%',
    },
});

export default FullScreenLoader;

